/**
 * 인덱스 정규화
 * @param {function} excuteFunc 
 * @param {Object} e 
 * @param {Number} messages_index_target 
 * @param {Number} row_index_target 
 * @param {Number} component_index_target 
 */
export const onDropComponent = (excuteFunc, e, messages_index_target, row_index_target=null, component_index_target=null) => {
  let draggedComponentPosition = {
    message_index_dragged: null,
    row_index_dragged: null,
    component_index_dragged: null,
  }
  let thisIndexPosition = {
    message_index_target: null,
    row_index_target: null,
    component_index_target: null,
  }
  let otherInfos = {
    rowIndexDetail: null,
    slidePageIndex: null,
  }
  if (!e) {
    const param = {
      ...draggedComponentPosition, 
      ...thisIndexPosition,
      ...otherInfos,
    }

    excuteFunc(param)
    return
  }
  const { type, prefix_type, messageIndex, rowIndex, componentIndex, row_index_detail, slide_page_index } = e

  draggedComponentPosition = {
    message_index_dragged: messageIndex,
    row_index_dragged: rowIndex || rowIndex === 0 ? rowIndex-1 : null,
    component_index_dragged: componentIndex || componentIndex === 0 ? componentIndex-1 : null,
  }
  thisIndexPosition = {
    message_index_target: messages_index_target,
    row_index_target: row_index_target || row_index_target === 0 ? row_index_target-1 : null,
    component_index_target: component_index_target || component_index_target === 0 ? component_index_target-1 : null,
  }
  otherInfos = {
    rowIndexDetail: row_index_detail || row_index_detail === 0 ? row_index_detail-1 : null,
    slidePageIndex: slide_page_index || slide_page_index === 0 ? slide_page_index-1 : null,
  }

  const param = {
    ...draggedComponentPosition, 
    ...thisIndexPosition,
    ...otherInfos,
  }

  excuteFunc(param)
}